import React from 'react';
import { CapitalGainsSummary } from '../../types';
import { formatCurrency } from '../../utils/formatters';
import styles from './GainsCard.module.css';

interface GainsCardProps {
  variant: 'pre' | 'after';
  stcg: CapitalGainsSummary;
  ltcg: CapitalGainsSummary;
  savings?: number;
}

export default React.memo(function GainsCard({ variant, stcg, ltcg, savings }: GainsCardProps) {
  const isPre = variant === 'pre';
  const netStcg = stcg.profits - stcg.losses;
  const netLtcg = ltcg.profits - ltcg.losses;
  const total = netStcg + netLtcg;
  const showSavings = !isPre && savings && savings > 0;



  return (
    <div
      className={`${styles.gainsCard} ${isPre ? styles.gainsCardPre : styles.gainsCardAfter}`}
    >
      <h2 className={`${styles.title} ${isPre ? styles.titlePre : styles.titleAfter}`}>
        {isPre ? 'Pre Harvesting' : 'After Harvesting'}
      </h2>

      <div className={styles.grid} role="table" aria-label="Capital gains breakdown">
        <div className={`${styles.label} ${!isPre ? styles.labelAfter : ""}`}>Short-term</div>
        <div className={`${styles.label} ${!isPre ? styles.labelAfter : ""}`}>Long-term</div>

        <div className={isPre ? styles.value : styles.valueAfter}>Profits</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(stcg.profits)}</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(ltcg.profits)}</div>

        <div className={isPre ? styles.value : styles.valueAfter}>Losses</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(stcg.losses)}</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(ltcg.losses)}</div>

        <div className={isPre ? styles.value : styles.valueAfter}>Net Capital Gains</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(netStcg)}</div>
        <div className={`${styles.value} ${!isPre ? styles.valueAfter : ""}`}>{formatCurrency(netLtcg)}</div>
      </div>

      <div className={`${styles.divider} ${!isPre ? styles.dividerAfter : ""}`}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: showSavings ? 10 : 0 }}>
          <span className={`${styles.summaryLabel} ${isPre ? styles.summaryLabelPre : styles.summaryLabelAfter}`}>
            {isPre ? 'Realised Capital Gains:' : 'Effective Capital Gains:'}
          </span>
          <span className={`${styles.summaryValue} ${isPre && total < 0 ? styles.summaryValuePreNegative : (isPre ? styles.summaryValuePrePositive : styles.summaryValueAfter)}`}>
            {formatCurrency(total)}
          </span>
        </div>

        {showSavings && (
          <div className={styles.savingsBadge}>
            <span>🎉</span>
            <span>Your taxable capital gains are reduced by: <strong>{formatCurrency(savings)}</strong></span>
          </div>
        )}
      </div>
    </div>
  );
});

